// extracted by mini-css-extract-plugin
export default {"loaderContainer":"ManageAccount_loaderContainer__XmBrY","iframe":"ManageAccount_iframe__GxetR"};